import { Configuration } from "@azure/msal-browser";

const CLIENT_CLIENT_ID =
  (window.FREIGHT_PRICING_PORTAL_ENV || {}).REACT_APP_CLIENT_CLIENT_ID ?? "";
const API_CLIENT_ID =
  (window.FREIGHT_PRICING_PORTAL_ENV || {}).REACT_APP_API_CLIENT_ID ?? "";
const TENANT_ID =
  (window.FREIGHT_PRICING_PORTAL_ENV || {}).REACT_APP_TENANT_ID ?? "";

const locationHost = window.location.origin;
export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: `${locationHost}/`,
    postLogoutRedirectUri: `${locationHost}/`,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    claimsBasedCachingEnabled: true,
  },
};

export const loginSilentRequest = {
  scopes: [
    `api://${API_CLIENT_ID}/CommonAPI`,
    `api://${API_CLIENT_ID}/PricingAPI`,
    `api://${API_CLIENT_ID}/AgreementAPI`,
    `api://${API_CLIENT_ID}/FollowUpAPI`,
    `api://${API_CLIENT_ID}/CustomerAPI`,
  ],
};
